export const PAGE_SIZE = 32
export const MAX_ITEMS_FOR_TRAIT_FILTERS = 30_000
export const DEFAULT_SORT = { by: "TOTAL_QUANTITY", direction: "DESC" } as const
export const DEFAULT_FILTER = {
  attributes: [],
  ownedQuantityRange: null,
}
